import { render, staticRenderFns } from "./dingdListGK.vue?vue&type=template&id=10c645d6&scoped=true"
import script from "./dingdListGK.vue?vue&type=script&lang=js"
export * from "./dingdListGK.vue?vue&type=script&lang=js"
import style0 from "./dingdListGK.vue?vue&type=style&index=0&id=10c645d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c645d6",
  null
  
)

export default component.exports